const config = {
  //backendServerHost:  'https://app.metabolytics.ai/simulator-backend',
  //backendServerHost: 'http://localhost:3001',
  backendServerHost: "https://app.metabolytics.ai/simulator-backend",
};

export default config;
